import React, { useContext, useState, useEffect } from 'react';
import { Row, Button, Upload, Icon, Col } from 'antd';
import { AuthContext } from '../../../context/auth';
import {
    useQuery,
    useMutation
} from "@apollo/client";
import { PERSONAL_DOCS } from '../../../utils/query';
import { UPLOAD_MUTATION } from '../../../utils/query';
import FormLoading from '../../../components/common/loaders/formLoading';
import Info from '../../../components/common/info';

export default function VerifyDocuments() {
    const { user } = useContext(AuthContext);

    const { loading, error, data } = useQuery(PERSONAL_DOCS);

    const [upload , { loading: uploadLoading, error: uploadError }] = useMutation(UPLOAD_MUTATION , {
        onCompleted(data) {
        }
    });


    if (user.user.documents_status === "rejected") {
        if (loading) return (
            <FormLoading />
        );
        if (error) return <p>مشکل در خواندن اطلاعات فایل‌ها از سرور</p>;
        if (data) {

            let fileList = []
            data.personalDocuments.data.forEach(item => {
                fileList.push(
                    {
                        uid: item.id,
                        name: item.attributes.document.data.attributes.ext,
                        status: 'done',
                        url: Info.UPLOADS_URL + item.attributes.document.data.attributes.url,
                        thumbUrl:Info.UPLOADS_URL +  item.attributes.document.data.attributes.url
                    }
                ); 
            });
            
        
            const uploadProps = {
                action: 'https://admin.bayatiexchange.com/api/upload',
                listType: 'picture',
                accept :"image/png, image/jpeg",
                defaultFileList: [...fileList],
                fileList: [...fileList],
                
                className: 'upload-list-inline',
            };

            return (
                <div>
                    <Row >
                        <Col span={24}>
                            <h4 style={{ marginBottom: 25 }}>{user.user.docs_validate_message}</h4>
                        </Col>
                        {
                            user.user.is_company === true ? (
                                <Col span={24} style={{ padding: '20px 10px 30px 10px' }}>
                                    <h3>مدارک مورد نیاز برای کاربر حقوقی</h3>
                                    <div className={"homeSliderDesc flex-row-center-center"}>
                                        <ul className={"homeSliderList"} style={{ direction: 'rtl' }}>
                                            <li className={"homeSliderListItem"}>
                                                تصویر اساس‌نامه شرکت
                                            </li>
                                            <li className={"homeSliderListItem"}>
                                                تصویر روزنامه رسمی
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                            ) : (
                                <Col span={24} style={{ padding: '20px 10px 30px 10px' }}>
                                    <h3>مدارک مورد نیاز برای اشخاص حقیقی</h3>
                                    <div className={"homeSliderDesc flex-row-center-center"}>
                                        <ul className={"homeSliderList"} style={{ direction: 'rtl' }}>
                                            <li className={"homeSliderListItem"}>
                                                تصویر روی کارت ملی
                                            </li>
                                            <li className={"homeSliderListItem"}>
                                                تصویر پشت کارت ملی
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                            )
                        }
                    </Row>
                    <Upload {...uploadProps}>
                        <Button>
                            <Icon type="plus-circle" /> بارگذاری فایل جدید
                        </Button>
                    </Upload>
                    <div className={"formSubmitButton"} style={{ marginTop: '40px' }}>
                        <div className={"normalButtonWrapper darkBtn"}>
                            <button type="submit" className={"normalButton loginButton"}>
                                <div className="normalButtonInner">
                                    <div>
                                        <Icon type={'upload'} />
                                    </div>
                                    <p>آپلود مدارک</p>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
    }
    if (user.user.documents_status === "approving") {
        return (
            <div>
                <h4 style={{ marginBottom: 25, paddingTop: 50, paddingBottom: 50 }}>مدارک شما در حال بررسی می‌باشد . نتیجه تا ۲۴ ساعت به شما اعلام می‌گردد</h4>
            </div>
        )
    }


}
